'use client';

import { useSearchParams } from 'next/navigation';

export const useQueryParams = () => {
  const searchParams = useSearchParams();

  const getParam = (key: string): string => searchParams?.get(key) ?? '';

  const getBool = (key: string, defaultValue: boolean = false): boolean => {
    const value = searchParams?.get(key);
    return value === null ? defaultValue : value === 'true' || value === 'True';
  };

  return {
    visitId: getParam('visitId'),
    notAcceptingBooking: getBool('notAcceptingBooking', true),
    phone: getParam('phone'),
    withAccountDetails: getBool('withAccountDetails', false),
    confirm: getBool('confirm', false),
    cancel: getBool('cancel', false),
    inviteToSplit: getBool('inviteToSplit', false)
  };
};

export const useVisitId = () => useQueryParams().visitId;

export const useHasVisitId = () => !!useVisitId();
